import React from 'react'
import {Form } from 'semantic-ui-react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import ReservationStatusesDropDown from '../../../components/shared/ReservationStatusesDropDown';
import { GetRoomPlannedMaintenance } from '../../../api/services/pms';
import {DatePicker} from '../../shared/DatePicker';
import  {useTextResources} from '../../../language';

const MaintenanceReport = ()=>{
    const text = useTextResources()
    const gridOptions = {
        search: {
            title: "Maintenance Report",
            description: "Some description",
            fields: [ 
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Field control={ReservationStatusesDropDown} width="4" multiple label= {text("ReservationStatus")} key="StatusTypeIDs"/>
            ],
            api: GetRoomPlannedMaintenance,
            spec: {
                GetPlannedMaintenanceStatusesContainedInRange: true,
                IncludeMaintenanceStatusType: true,
                IncludeRoom: true,
                IncludeUser: true,
                IsActive: true
            }
        },
        grid: {
            menu: {
                left: [
                    
                ],
                right: [
                    
                ]
            },
            columns: [
                { name: 'Room', title: 'Room' }
               // { name: 'CloudPassword', title: 'Cloud Password' },
               // { name: 'UserHotels', title: 'Hotels', displayField: "HotelName", valueField: "HotelID", editor: <HotelsDropDown search multiple data={hotelsFromApi} /> },
               // { name: 'User', title: 'Users', displayField: "UserName", valueField: "Id", customProps: customPropsCallback, editor: <UsersDropDown search multiple />},
                
            ],
            selectable: true
        }
    }

    return (<GridSearchTemplate options={gridOptions}/>)
}

export default MaintenanceReport